import { Divider, Paper, Typography } from "@mui/material";
import { useUpdateRandomQueueDisplayer } from "../../hooks/randomMode/useUpdateRandomQueueDisplayer";
import NextAlbumsDisplayer from "./NextAlbumsDisplayer";
import CurrentAlbumDisplayer from "./CurrentAlbumDisplayer";
import PreviousAlbumsDisplayer from "./PreviousAlbumsDisplayer";
import RandomModeStartButton from "./RandomModeStartButton";
import { EditModeButton, StopModeButton, RepeatModeButton, ShuffleButton, StartQueueButton } from "./RandomQueueControls";

const RandomQueueDisplayer = () => {
    const { queuePointer, emptyQueue, previousAlbums, currentAlbum, nextAlbums } = useUpdateRandomQueueDisplayer();

    return (
        <>
            <Paper className="full-height bs-border-box relative-position">
                <div className="d-flex flex-column full-height">
                    <div className="d-flex flex-column gap-0_5 p-1 pb-0_5">
                        <div className="d-flex flex-row gap-1 ai-center">
                            <RandomModeStartButton emptyQueue={emptyQueue} /> 
                            <Typography variant="h5">Random mode</Typography>
                        </div>
                        <Divider />
                        <div className="d-flex flex-row full-width jc-end ai-center relative-position gap-0_5">
                            <ShuffleButton emptyQueue={emptyQueue} />
                            <RepeatModeButton emptyQueue={emptyQueue} />
                            <EditModeButton emptyQueue={emptyQueue} />
                            <StopModeButton emptyQueue={emptyQueue} />
                        </div>
                        <Divider />
                    </div>
                    <div className="overflow-y-scroll overflow-x-hidden flex-1 p-1 pt-0_5">
                        {
                            !emptyQueue ?
                            <div className="d-flex flex-column jc-center ai-center gap-1 full-width">
                                <PreviousAlbumsDisplayer
                                    previousAlbums={previousAlbums}
                                    canAdd={currentAlbum} />
                                <CurrentAlbumDisplayer
                                    currentAlbum={currentAlbum}
                                    queuePointer={queuePointer} />
                                <NextAlbumsDisplayer 
                                    nextAlbums={nextAlbums} 
                                    queuePointer={queuePointer} />
                            </div> :
                            <div className="d-flex flex-column jc-center ai-center gap-0_5">
                                <Typography>The random mode queue is currently empty</Typography>
                                <StartQueueButton />
                            </div>
                        }
                    </div>
                </div>
            </Paper>
        </>
    )
}

export default RandomQueueDisplayer;